import { FormControl, FormGroup } from '@angular/forms';

export interface IQuickCheckoutForm {
  commPrefs: FormGroup<{
    commPrefsPhone: FormControl<boolean | null>;
    commPrefsSms: FormControl<boolean | null>;
  }>;
  contactSmsAllowed: FormControl<boolean | null>;
  birthDate: FormControl<string | null>;
  email: FormControl<string | null>;
  firstName: FormControl<string | null>;
  insurance: FormControl<number | null>;
  lastName: FormControl<string | null>;
  location: FormControl<string | null>;
  paymentType: FormControl<PaymentTypes | null>;
  phone: FormControl<string | null>;
}

export interface IQuickCheckoutFormValues {
  commPrefs: string[];
  contactSmsAllowed: boolean;
  dateOfBirth: string | null;
  email: string | null;
  firstName: string | null;
  insurance: number | null;
  lastName: string | null;
  location: string | null;
  personaProviderId: number | null;
  phone: string | null;
  source: string | null;
}

export interface IQuickCheckoutReferralCreationRequest {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  received_date: string;
  source_attributes: {
    state: string; // 'OH'
    source: string; // 'PSL Referral'
    birthdate: string;
    insurance: number;
    persona_provider_id: number; // id of selected provider
    contact_sms_allowed: boolean;
    comm_prefs: string[];
  };
}

export interface IQuickCheckoutApiResponse {
  referral_request_uuid: string;
}

export enum PaymentTypes {
  EAP = 'Employee assistance program (EAP)',
  MEDICARE = 'Medicare or Medicare Advantage',
  INSURANCE = 'Health insurance',
  CASH = 'I\'ll pay for therapy myself'
}
